import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardText} from 'material-ui/Card';

const styles = {
    cardContainer: {minWidth: 800, margin: 0, padding: 0},
    card: {minHeight: 50, margin: 0, padding: 0, borderRadius: 0, boxShadow: 'none'},
    cardHeader: {margin: '-10px 0 0 0', padding: '9px 16px 9px 16px'},
    cardHeaderText: {padding: '0 0 0 22px'},
    cardText: {margin: 0, padding: 0}
};

/**
 * A class for a table container with expand/collapse capability
 */
export class ExpandableTableContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: props.defaultOpen
        };
    }

    handleExpandChange = (expanded) => {
        this.setState({expanded: expanded});
    };

    render() {
        return (
            <Card
                initiallyExpanded={true}
                onExpandChange={this.handleExpandChange}
                containerStyle={styles.cardContainer}
                style={styles.card}
                className="table-expandable-container"
            >
                <CardHeader
                    title={(this.state.expanded) ? 'Hide Table' : 'Show Table'}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={styles.cardHeader}
                    textStyle={styles.cardHeaderText}
                    className="table-expandable-header"
                />
                <CardText expandable={true} style={styles.cardText} className="table-expandable">
                    {this.props.children}
                </CardText>
            </Card>
        );
    }
}

ExpandableTableContainer.propTypes = {
    children: PropTypes.node,
    defaultOpen: PropTypes.bool
};

ExpandableTableContainer.defaultProps = {
    defaultOpen: true
};

export default ExpandableTableContainer;



// WEBPACK FOOTER //
// ./src/Fuse/components/ExpandableTableContainer.js